(ns livefeed.analytics
  (:require
   [livefeed.properties :refer [get-property]]))

(defonce ^:private sdk-ready? (atom false))
(defonce ^:private events (atom []))
(defonce ^:private pending-track-page? (atom false))

(defn ^:private track-page*  []
  (let [view_id (random-uuid)
        chat_id (get-property :chatId)]
    (.yleSnowplow
     js/window
     "trackSelfDescribingEvent"
     #js {:event #js
                  {:schema "iglu:fi.yle.engagement/view/jsonschema/2-11-0",
                   :data #js {:view_id (str view_id),
                              :view_type "entity",
                              :view_entity_type "chat",
                              :view_mode "full"}},
          :context #js [#js {:schema "iglu:fi.yle.content/chat/jsonschema/2-0-0",
                             :data #js {:chat_id chat_id,
                                        :predicate "engagement_view_target"}}]})))

(defn ^:private track-event* [{:keys [category action]}]
  (let [event
        #js {:event #js {:schema "iglu:fi.yle.engagement/click/jsonschema/2-2-0"
                         :data #js {:click_id (str (.now js/Date) "-" (rand-int 100000) "-" (rand-int 100000) "-" (rand-int 100000))
                                    :action "select"}}
             :context #js [#js {:schema "iglu:fi.yle.engagement/attribute/jsonschema/3-5-0"
                                :data #js {:category category
                                           :action action
                                           :component "chat"}}]}]

    (.yleSnowplow js/window "trackSelfDescribingEvent" event)))

(defn ^:private flush-events []
  (when @pending-track-page? (track-page*))
  (run! track-event* @events)
  (reset! pending-track-page? false)
  (reset! events []))

(def ^:private webview? (-> js/document .-documentElement (.hasAttribute "data-webview")))

(def ^:private sp-script ";(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[]; p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments) };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1; n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,'script','/js/sp.lite.js','yleSnowplow'));")

(defn init []
  (when-not @sdk-ready?
    ;; Whoever owns the page has the responsibility of initializing
    ;; window.yleSnowplow. For the webview page, that's us.
    (when webview?
      (let [sp-script-el (doto (-> js/document (.createElement "script"))
                           (-> .-innerHTML (set! sp-script)))]
        (-> js/document .-body (.append sp-script-el))
        (let [env (-> js/window .getEnv)
              app-id (if (= env "production")
                       "chat-prod"
                       "chat-test")]
          (-> js/window (.yleSnowplow "addPlugin" "/js/sp-webview-plugin.js"
                                      (clj->js ["snowplowWebViewTracking", "WebViewPlugin"])))
          ;; We leave the collector URL unset as this tracker's WebView plugin
          ;; will simply forward the events to the embedding app's tracker.
          (-> js/window (.yleSnowplow "newTracker" "sp1" ""
                                      (clj->js {:appId app-id}))))
        (-> js/window .-yleSnowplowReady (set! (-> js/Promise .resolve)))))

    (when-let [ready-promise (.-yleSnowplowReady js/window)]
      (-> ready-promise
          (.then (fn []
                   (let [sp-language (case (get-property :language)
                                       :fi "fin"
                                       :sv "swe"
                                       :en "eng"
                                       "und")]
                     (-> js/window
                         (.yleSnowplow
                          "addGlobalContexts"
                          (clj->js {:yleContext {:schema "iglu:fi.yle/yle_context/jsonschema/2-25-0"
                                                 :data {:main_service "muut"
                                                        :service "chat-web"
                                                        :section "chat"
                                                        :subsection nil
                                                        :country_code nil
                                                        :service_language sp-language
                                                        :content_language sp-language
                                                        :wrapper_type (if webview?
                                                                        "webview"
                                                                        "web")
                                                        :context_index (if webview?
                                                                         2
                                                                         1)}}}))))
                   (reset! sdk-ready? true)
                   (flush-events)))
          (.catch (fn [err]
                    (js/console.log "Snowplow SDK promise rejected:" err)))))))

(defn track-event [category action]
  (let [event {:category category :action action}]
    (if @sdk-ready?
      (track-event* event)
      (swap! events conj event)))
  true)

(defn track-page []
  (if @sdk-ready?
    (track-page*)
    (reset! pending-track-page? true))
  true)
